import state from './state'
import CalculationHelper from '../../util/CalculationHelper'
import _ from 'lodash'

const helper = {
  loadSettings: (settings) => {
    // Old item calculation by item size, distance and offset
    // const radiusInPx = helper.getDistanceToCenter()
    // console.log('radiusInPx', radiusInPx)
    // const radiusInPx = CalculationHelper.convertInPixel(state.menuItemBubble.distanceToCenter)
    // const circumference = CalculationHelper.calculateCircumference(radiusInPx)
    // const menuItemBubbleComputedSize = state.menuItemBubble.size * state.menuItemBubble.defaultOffset
    // const maxItems = CalculationHelper.calculateMaxItems(circumference, menuItemBubbleComputedSize)
    // const defaultAngle = CalculationHelper.calculateDefaultAngle(maxItems)

    helper.setDefaultAngle(CalculationHelper.calculateDefaultAngle(helper.getMaxItemsPerPage()))
  },

  // setter
  setRouter: (router) => {
    state.app.router = router
  },

  setAppContainerSize (size) {
    state.app.containerSize = size
  },

  getAppContainerSize () {
    return state.app.containerSize
  },

  setInitialRoute: (route) => {
    state.app.initialRoute = route
  },

  setDefaultAngle (value) {
    state.menuItemBubble.defaultAngle = value
  },

  setShowActions (value) {
    state.app.showActions = value
  },

  setDraggableBubblesEnabled (value) {
    state.app.draggableBubbles = value
  },

  setItemsPerPage (itemsPerPage) {
    state.app.itemsPerPage = itemsPerPage
  },

  setPaginationEnabled (value) {
    state.pagination.enabled = value
  },

  setMenuItemBubbleSettings (settings) {
    state.menuItemBubble = { ...state.menuItemBubble, ...settings }
  },

  setMenuMainBubbleSettings (settings) {
    state.menuMainBubble = { ...state.menuMainBubble, ...settings }
  },

  setBreadcrumbSettings (settings) {
    state.breadcrumb = { ...state.breadcrumb, ...settings }
  },

  setPaginationSettings (settings) {
    state.pagination = { ...state.pagination, ...settings }
  },

  setBackButtonSettings (settings) {
    state.backButton = { ...state.backButton, ...settings }
  },

  // getter
  getRouter: () => {
    return _.get(state.app, 'router', null)
  },

  getInitialRoute: () => {
    return _.get(state.app, 'initialRoute', null)
  },

  getInitialRouteName () {
    return _.get(helper.getInitialRoute(), 'name', '')
  },

  getInitialRoutePath () {
    return _.get(helper.getInitialRoute(), 'path', '')
  },

  getDistanceToCenter: () => {
    const percentageOfContainer = _.get(state.menuItemBubble, 'distanceToCenter', 0)
    const halfAppContainerSize = helper.getAppContainerSize() / 2

    return halfAppContainerSize * percentageOfContainer
  },

  getDefaultAngle: () => {
    return _.get(state.menuItemBubble, 'defaultAngle', 0)
  },

  getMaxItemsPerPage: () => {
    return _.get(state.app, 'itemsPerPage', 0)
  },

  getMenuItemBubbleSize: () => {
    const percentageOfContainer = _.get(state.menuItemBubble, 'size', 0)
    return Math.min(helper.getAppContainerSize() * percentageOfContainer, helper.getMenuItemBubbleSizeMax())
  },

  getMenuItemBubbleSizeMax: () => {
    return _.get(state.menuItemBubble, 'maxSize')
  },

  getMenuMainBubbleSize: () => {
    const percentageOfContainer = _.get(state.menuMainBubble, 'size', 0)
    return helper.getAppContainerSize() * percentageOfContainer
  },

  getShowActions () {
    return _.get(state.app, 'showActions', false)
  },

  getBreadcrumbItemSize () {
    return state.breadcrumb.item.size
  },

  getBreadcrumbColors () {
    return state.breadcrumb.colors
  },

  getBreadcrumbHomeLabel () {
    return state.breadcrumb.homeLabel
  },

  getMenuItemBubbleDefaultClasses () {
    return state.menuItemBubble.classes
  },

  getMenuMainBubbleDefaultClasses () {
    return state.menuItemBubble.classes
  },

  getBreadcrumbItemDefaultClasses () {
    return state.breadcrumb.item.classes
  },

  getBreadcrumbItemActiveClasses () {
    return state.breadcrumb.item.activeClasses
  },

  getBackButtonConfig () {
    return state.backButton
  },

  getBackBubbleSize () {
    const percentageOfContainer = _.get(state.backButton, 'size')
    return helper.getAppContainerSize() * percentageOfContainer
  },

  getPaginationButtonSize () {
    const percentageOfContainer = _.get(state.pagination, 'buttonSize')
    return helper.getAppContainerSize() * percentageOfContainer
  },

  getPaginationPrevButtonConfig () {
    return state.pagination.buttonPrev
  },

  getPaginationNextButtonConfig () {
    return state.pagination.buttonNext
  },

  // helper
  isDraggableBubblesEnabled () {
    return _.get(state.app, 'draggableBubbles', false)
  },

  isPaginationEnabled () {
    return _.get(state.pagination, 'enabled', false)
  },

  isBreadcrumbShowHomeEnabled () {
    return _.get(state.breadcrumb, 'showHomeItem', false)
  },

  isBreadcrumbEnabled () {
    return _.get(state.breadcrumb, 'enabled', false)
  },

  isInitialRoute: (routeName) => {
    return _.isEqual(routeName, helper.getInitialRouteName())
  }
}

export default helper
